// Shared utilities and types (root level)
export * from "./types";
export * from "./utils";

// Shared cross-entity hooks
export * from "./shared";

// CRM entities
export * from "@/features/contacts/hooks";
export * from "./companies";
export * from "./deals";
export * from "./tickets";
export * from "./tasks";
export * from "./communications";
export * from "./timeline";
export * from "./offerings";
export * from "./msp-docs";
export * from "./time-entries";

// Inbox / messaging
export * from "./messages";

// Email
export * from "./emails";

// Dashboard and analytics
export * from "./dashboard";
export * from "./analytics";

// Users, employees, admin
export * from "./users";
export {
  type AdminQBCustomerRow,
  useAdminQuickBooksEntitiesByRealm,
  useAdminQuickBooksEntitiesMultiRealm,
  useAdminQuickBooksEntities,
  useAdminQuickBooksCustomers,
  useMatchQBCustomer,
  useRemoveQBCustomerMapping,
  useUserProfile,
  useUpdateUserProfile,
  useEmployeeClientAccess,
  useContactEmployeeAccess,
} from "./admin";

// Reports
export * from "./reports";

// Client portal
export * from "./client-portal";

// Integrations
export * from "./quickbooks";
export * from "./connection-sharing";

// Automation
export * from "./automation";

// Search
export * from "./search";

// Saved views
export * from "./saved-views";

// Tagging
export * from "./tags";

// Validation
export * from "./validation";

// Contracts (named exports to avoid conflicts)
export {
  useContractGeneration,
  useContactProposals,
  useUserProposals,
  useCreateProposal,
  useUpdateProposal,
  useDeleteProposal,
  useContractTemplates,
  useTemplateGroups,
  useTemplateSchema,
  useContactContractStats,
  useUserContractStats,
  useBulkUpdateContractStatus,
  useBulkDeleteContracts,
  useBulkExportContracts,
} from "./contracts";
